import React from 'react'
import { NiceComponent } from '../components/NiceComponent'

export const NiceTestView = ({ API_ENDPOINT, CDN_ENDPOINT, ...props }) => {
	return <NiceComponent API_ENDPOINT={API_ENDPOINT} CDN_ENDPOINT={CDN_ENDPOINT} />
}
